'use client';

import { Grid, GridItem } from '@coolblue-development/freddy';
import { ReactNode } from 'react';

import { useSummaryStore } from '../../SummaryStore';

type Props = {
  productImage: ReactNode;
  productSummary: ReactNode;
  complementaryItems: ReactNode;
};
export default function ProductSummaryGrid({
  productImage,
  productSummary,
  complementaryItems
}: Props) {
  const { items } = useSummaryStore();

  if (items.length === 0) {
    return (
      <Grid
        templateColumns='auto 1fr'
        templateAreas={{ xs: `"product-image product-info"` }}
        gap={200}
        alignItems='top'
      >
        <GridItem area='product-image'>{productImage}</GridItem>
        <GridItem area='product-info'>{productSummary}</GridItem>
      </Grid>
    );
  }

  return (
    <Grid
      templateRows='auto 1fr'
      templateColumns='auto 1fr'
      templateAreas={{
        xs: `
    "product-image product-info"
    "complementary-items complementary-items"
  `,
        md: `
    "product-image product-info"
    "product-image complementary-items"
  `
      }}
      gap={200}
      role='group'
      aria-labelledby={'product-summary-block'}
    >
      <GridItem area='product-image'>{productImage}</GridItem>
      <GridItem area='product-info'>{productSummary}</GridItem>
      <GridItem area='complementary-items'>{complementaryItems}</GridItem>
    </Grid>
  );
}
